<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $tc('models.invoice', 2) }}
        </h1>
      </v-flex>

      <PendingInvoicesComp></PendingInvoicesComp>

      <GeneratedInvoicesComp></GeneratedInvoicesComp>
    </v-layout>
  </v-container>
</template>

<script>
import PendingInvoicesComp from '@/components/invoices/pending'
import GeneratedInvoicesComp from '@/components/invoices/generated'

export default {
  name: "InvoicesIndexView",

  data () {
    return {
    }
  },

  props: {
  },

  components: {
    PendingInvoicesComp,
    GeneratedInvoicesComp,
  },

  computed: {
  },

  methods: {
  },

  watch: {
  },

  mounted () {
  }
}
</script>
